import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Introduction() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/true-wine/intro_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={666}
              height={395}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#207146" }}>Introduction</span>
            </h2>
            <p>
              Unity is strength, and great communities are built on foundations
              of strong networks and collaboration. The goal was to create a
              social networking platform that could unite churches and people
              for an efficient exchange of services, information and monetary
              contributions.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Introduction;
